// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"8ed9ba18","198":"350a3707","286":"3b668392","289":"0eea98b7","315":"528e1069","371":"e487e492","407":"15f846f2","412":"88627604","605":"a6fecd22","619":"86d6baa5","841":"513d2ada","921":"c1ea0739","928":"f111265e","954":"c3ba0ee7","977":"f3425bfa"}[chunkId] + ".chunk.js";
};